import SunCalc from "suncalc";

// Approximate coordinates for common time zones, so moonrise can be shown without asking for location.
const ZONES = {
  "Australia/Sydney": [-33.87, 151.21], "Australia/Melbourne": [-37.81, 144.96], "Australia/Brisbane": [-27.47, 153.03],
  "Australia/Adelaide": [-34.93, 138.6], "Australia/Perth": [-31.95, 115.86], "Australia/Hobart": [-42.88, 147.33],
  "Australia/Darwin": [-12.46, 130.84], "Pacific/Auckland": [-36.85, 174.76], "Asia/Tokyo": [35.68, 139.69],
  "Asia/Singapore": [1.35, 103.82], "Asia/Kolkata": [19.08, 72.88], "Asia/Calcutta": [19.08, 72.88], "Asia/Dubai": [25.2, 55.27],
  "Asia/Bangkok": [13.76, 100.5], "Asia/Hong_Kong": [22.32, 114.17], "Asia/Shanghai": [31.23, 121.47], "Asia/Jakarta": [-6.2, 106.85],
  "Asia/Makassar": [-8.65, 115.22], "Europe/London": [51.51, -0.13], "Europe/Dublin": [53.35, -6.26], "Europe/Paris": [48.86, 2.35],
  "Europe/Berlin": [52.52, 13.4], "Europe/Amsterdam": [52.37, 4.9], "Europe/Madrid": [40.42, -3.7], "Europe/Lisbon": [38.72, -9.14],
  "Europe/Rome": [41.9, 12.5], "Europe/Athens": [37.98, 23.73], "Europe/Stockholm": [59.33, 18.07], "Africa/Johannesburg": [-26.2, 28.05],
  "America/New_York": [40.71, -74.01], "America/Toronto": [43.65, -79.38], "America/Chicago": [41.88, -87.63],
  "America/Denver": [39.74, -104.99], "America/Phoenix": [33.45, -112.07], "America/Los_Angeles": [34.05, -118.24],
  "America/Vancouver": [49.28, -123.12], "America/Mexico_City": [19.43, -99.13], "America/Sao_Paulo": [-23.55, -46.63],
  "America/Buenos_Aires": [-34.6, -58.38], "Pacific/Honolulu": [21.31, -157.86],
};
const SYDNEY = ZONES["Australia/Sydney"];

const zoneCoords = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (ZONES[tz]) return ZONES[tz];
    const offsetHours = -new Date().getTimezoneOffset() / 60;
    return [tz?.startsWith("Australia") || tz?.startsWith("Pacific") ? -30 : 35, Math.max(-180, Math.min(180, offsetHours * 15))];
  } catch {
    return SYDNEY;
  }
};

// Uses the visitor's exact location only if they have already granted it to this site; never prompts.
const grantedCoords = async () => {
  try {
    const p = await navigator.permissions?.query({ name: "geolocation" });
    if (p?.state !== "granted") return null;
    return await new Promise((resolve) => {
      navigator.geolocation.getCurrentPosition((pos) => resolve([pos.coords.latitude, pos.coords.longitude]), () => resolve(null), { maximumAge: 3600000, timeout: 4000 });
    });
  } catch {
    return null;
  }
};

export async function tonightsMoonrise(now = new Date()) {
  const [lat, lng] = (await grantedCoords()) ?? zoneCoords();
  const from = new Date(now);
  from.setHours(12, 0, 0, 0);
  const days = [new Date(from), new Date(from.getTime() + 86400000)].map((d) => {
    d.setHours(0, 0, 0, 0);
    return SunCalc.getMoonTimes(d, lat, lng).rise;
  });
  // Tonight = the next rise from midday today (or the one just past if the moon is already up this evening).
  const rise = days.find((t) => t && t >= from) ?? days[0];
  return rise ?? null;
}

export const fmtMoonrise = (d) => d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
